<template>
  <div :class="{'text-success': satisfied}">
    <i :class="{'fa-square': !satisfied, 'fa-check-square': satisfied}" class="far mx-2" aria-hidden="true"></i>
    <span>{{ text }}</span>
  </div>
</template>

<script>
export default {
  name: 'password-requirement',
  props: {
    satisfied: {
      type: Boolean,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
  },
};
</script>
